import "./Sidebar.css";
import { NavLink } from "react-router-dom";
import { useGlobal } from "../../context/GlobalContext";
import { Selector } from "../common/Selector";

export function Sidebar() {
    const { projects, selectedProjectKey, setSelectedProjectKey } = useGlobal();

    const projectOptions = projects.map(p => ({
        key: p.projectKey,
        label: p.projectName
    }));

    return (
        <aside className="sidebar">
            <div className="project-selector-wrapper">
                <Selector
                    options={projectOptions}
                    selectedKey={selectedProjectKey}
                    onSelect={setSelectedProjectKey}
                    placeholder="Select Project"
                />
            </div>
            
            <nav className="sidebar-nav">
                <NavLink to="/overview" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                    Overview
                </NavLink>
                <NavLink to="/agents" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                    Agents
                </NavLink>
                <NavLink to="/sessions" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                    Sessions
                </NavLink>
            </nav>
        </aside>
    );
}
